"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const types_1 = require("../types");
const constants_1 = require("../constants");
function newTracedFetch({ timeoutMs, localLogger, }) {
    return (traceId, url, requestInit) => __awaiter(this, void 0, void 0, function* () {
        localLogger(types_1.LogLevel.Debug, `Fetching ${url}...`, Object.assign({ traceId }, requestInit));
        const controller = new AbortController();
        const id = setTimeout(() => controller.abort(), timeoutMs);
        try {
            const response = yield (0, cross_fetch_1.default)(url, Object.assign(Object.assign({}, requestInit), { headers: Object.assign(Object.assign({}, requestInit.headers), { [constants_1.traceIdHeaderName]: traceId }), signal: controller.signal }));
            localLogger(types_1.LogLevel.Debug, `Successfully fetched ${url}`, {
                traceId,
                headers: Object.assign({}, response.headers),
                status: response.status,
            });
            return response;
        }
        finally {
            clearTimeout(id);
        }
    });
}
exports.default = newTracedFetch;
//# sourceMappingURL=newTracedFetch.js.map